import React from "react";
import { ExtractionMethodRow } from "../../data/api/ocrQualityApi";

interface OcrExtractionMethodTableProps {
  data: ExtractionMethodRow[];
}

export const OcrExtractionMethodTable: React.FC<OcrExtractionMethodTableProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={containerStyle}>
        <div style={headingStyle}>Extraction Method Comparison</div>
        <div style={{ color: "#6b7280", fontSize: 14, padding: "32px 0", textAlign: "center" }}>
          No extraction method data available.
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={headingStyle}>Extraction Method Comparison</div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
              <Th>Method</Th>
              <Th align="right">Documents</Th>
              <Th align="right">Avg Accuracy</Th>
              <Th align="right">Avg Edits/Doc</Th>
              <Th align="right">Zero-Edit Rate</Th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.extraction_method} style={{ borderBottom: "1px solid #f3f4f6" }}>
                <td style={tdBase}>
                  <span
                    style={{
                      background: "#eff6ff",
                      color: "#1d4ed8",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    {row.extraction_method ?? "unknown"}
                  </span>
                </td>
                <td style={{ ...tdBase, textAlign: "right" }}>{row.total_documents}</td>
                <td style={{ ...tdBase, textAlign: "right", color: accuracyColor(row.avg_accuracy) }}>
                  {Number(row.avg_accuracy).toFixed(1)}%
                </td>
                <td style={{ ...tdBase, textAlign: "right" }}>{Number(row.avg_edits).toFixed(1)}</td>
                <td style={{ ...tdBase, textAlign: "right" }}>{Number(row.zero_edit_rate_pct).toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

function accuracyColor(pct: number | string): string {
  const n = Number(pct);
  if (n >= 80) return "#16a34a";
  if (n >= 60) return "#d97706";
  return "#dc2626";
}

const Th: React.FC<{ children: React.ReactNode; align?: "right" | "left" }> = ({
  children,
  align = "left",
}) => (
  <th
    style={{
      padding: "8px 12px",
      textAlign: align,
      fontSize: 12,
      fontWeight: 600,
      color: "#6b7280",
    }}
  >
    {children}
  </th>
);

const tdBase: React.CSSProperties = {
  padding: "10px 12px",
  fontSize: 13,
  color: "#374151",
};

const containerStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: "20px 24px",
};

const headingStyle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 600,
  color: "#111827",
  marginBottom: 16,
};
